import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2fa732fc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "change-password"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-tips"
}, "请输入新密码，并尽量避免设置与常用软件、网站相同的密码组合", -1));
const _hoisted_3 = {
  class: "test-content"
};
import MainButton from '@/components/MainButton/MainButton.vue';
import { ref, getCurrentInstance } from 'vue';
import { findPwd } from '@/api/phone/password-change';
import { useRoute, useRouter } from 'vue-router';
import { loginOut } from '@/utils/navitiveApi/common';
import { showDialog } from "vant";
export default /*#__PURE__*/_defineComponent({
  __name: 'Changepwd',
  setup(__props) {
    var _getCurrentInstance$p, _getCurrentInstance;
    const router = useRouter();
    const route = useRoute();
    const {
      $alert,
      $loading
    } = (_getCurrentInstance$p = (_getCurrentInstance = getCurrentInstance()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.proxy) !== null && _getCurrentInstance$p !== void 0 ? _getCurrentInstance$p : {};
    const newpassword = ref(null);
    const repeatpassword = ref(null);
    const pwdtypes = ref('password');
    const pwdtypet = ref('password');
    const eyess = ref('closed-eye');
    const eyest = ref('closed-eye');
    const clickicons = () => {
      if (eyess.value == 'eye-o') {
        eyess.value = 'closed-eye';
        pwdtypes.value = 'password';
      } else {
        eyess.value = 'eye-o';
        pwdtypes.value = 'text';
      }
    };
    const clickicont = () => {
      if (eyest.value == 'eye-o') {
        eyest.value = 'closed-eye';
        pwdtypet.value = 'password';
      } else {
        eyest.value = 'eye-o';
        pwdtypet.value = 'text';
      }
    };
    const onClickNext = async () => {
      $loading.openLoading();
      const passToken = sessionStorage.getItem('store');
      console.log('passToken', passToken);
      const req = {
        passToken: passToken,
        pwdNew: newpassword.value
      };
      console.log('newpassword.value', newpassword.value, 'repeatpassword.value', repeatpassword.value);
      if (newpassword.value !== repeatpassword.value) {
        $loading.closeLoading();
        $alert({
          message: '新密码与重复密码不一致'
        });
        return;
      } else {
        try {
          const {
            code,
            data,
            message
          } = await findPwd(req);
          if (code !== 9000) {
            $loading.closeLoading();
            $alert({
              message
            });
            return;
          } else {
            $loading.closeLoading();
            showDialog({
              message: data + '，请重新登录',
              showConfirmButton: false
            });
            setTimeout(() => {
              loginOut();
            }, 1000);
          }
        } catch (e) {
          $loading.closeLoading();
          $alert(e);
        }
      }
    };
    return (_ctx, _cache) => {
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_cell_group, null, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          modelValue: newpassword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => newpassword.value = $event),
          type: pwdtypes.value,
          label: "新密码",
          placeholder: "请设置6-20位数字与字母的组合",
          "right-icon": eyess.value,
          onClickRightIcon: clickicons
        }, null, 8, ["modelValue", "type", "right-icon"]), _createVNode(_component_van_field, {
          modelValue: repeatpassword.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => repeatpassword.value = $event),
          type: pwdtypet.value,
          label: "重复新密码",
          placeholder: "请重复输入您设置的新密码",
          "right-icon": eyest.value,
          onClickRightIcon: clickicont
        }, null, 8, ["modelValue", "type", "right-icon"])]),
        _: 1
      }), _createVNode(MainButton, {
        onClick: onClickNext
      }, {
        default: _withCtx(() => [_createTextVNode("下一步")]),
        _: 1
      })])]);
    };
  }
});